export const BLOCK_CHAT_MARKER_KINDS = ["artifact-thumbnail", "artifact-table"] as const
export const CHAT_MARKER_KINDS = [...BLOCK_CHAT_MARKER_KINDS, "scroll-to-form"] as const

export type ChatMarkerKind = (typeof CHAT_MARKER_KINDS)[number]

export interface ChatMarker {
  kind: ChatMarkerKind
  id: string
}

export const CHAT_MARKER_TAG_NAMES = CHAT_MARKER_KINDS.join("|")

const CHAT_MARKER_HREF_PREFIX = "/chat-markers/"
const CHAT_MARKER_KIND_SET: ReadonlySet<string> = new Set(CHAT_MARKER_KINDS)
const BLOCK_CHAT_MARKER_KIND_SET: ReadonlySet<string> = new Set(BLOCK_CHAT_MARKER_KINDS)

export function isChatMarkerKind(value: string): value is ChatMarkerKind {
  return CHAT_MARKER_KIND_SET.has(value)
}

export function chatMarkerHref(marker: ChatMarker): string {
  return `${CHAT_MARKER_HREF_PREFIX}${marker.kind}/${encodeURIComponent(marker.id)}`
}

function decodedMarkerId(encodedId: string): string | null {
  try {
    return decodeURIComponent(encodedId)
  } catch {
    return null
  }
}

export function parseChatMarkerHref(href: string): ChatMarker | null {
  if (!href.startsWith(CHAT_MARKER_HREF_PREFIX)) return null
  const [kind, encodedId, ...rest] = href.slice(CHAT_MARKER_HREF_PREFIX.length).split("/")
  if (!kind || !encodedId || rest.length > 0 || !isChatMarkerKind(kind)) return null
  const id = decodedMarkerId(encodedId)
  return id === null ? null : { kind, id }
}

export function isBlockChatMarkerHref(href: string): boolean {
  const marker = parseChatMarkerHref(href)
  return marker !== null && BLOCK_CHAT_MARKER_KIND_SET.has(marker.kind)
}
